import { ReportPredicate } from './report/report-predicate.model';

export class DiscrepanciesRequest {
  dateFrom: string;
  dateTo: string;
  adUnitIds: string[];
  includeAvgData?: boolean;
  activeUnits?: boolean;
  demandPartnerIds: string[];
  predicates: ReportPredicate[];
  groupByDate?: boolean;
  groupByDp?: boolean;
  dataSource?: DiscrepancyReportRequestDataSource;
}

export enum DiscrepancyReportRequestDataSource {
  DFP = 'DFP',
  SB = 'SB',
}
